import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[CONSTANTINOV] Unhandled error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
            maxWidth: 640,
            margin: "80px auto",
            padding: "40px 24px",
            textAlign: "center",
            color: "#2B2420",
          }}
        >
          <div
            style={{
              fontSize: 11,
              letterSpacing: "0.25em",
              textTransform: "uppercase",
              color: "#B8732C",
              fontWeight: 700,
              marginBottom: 16,
            }}
          >
            CONSTANTINOV LTD
          </div>
          <h1 style={{ fontSize: 32, margin: "0 0 16px", fontWeight: 800 }}>
            We'll be right back.
          </h1>
          <p style={{ color: "#4D4037", lineHeight: 1.6, margin: "0 0 24px" }}>
            The site couldn't load a module. Please refresh the page, or call
            Ion on <a href="tel:+447591836115" style={{ color: "#B8732C" }}>07591 836115</a>{" "}
            and we'll help you straight away.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              background: "#B8732C",
              color: "#fff",
              border: 0,
              padding: "14px 22px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              cursor: "pointer",
              fontSize: 13,
            }}
          >
            Refresh page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
